class CommonService {

    saveLang(lang) {
        localStorage.setItem("i18nextLng", lang)
    }

    getLang() {
        return localStorage.getItem("i18nextLng") || "en"
    }

    saveTxRiskLevels(txRiskLevels) {
        localStorage.setItem("txRiskLevels", JSON.stringify(txRiskLevels))
    }

    getTxRiskLevels() {
        return JSON.parse(localStorage.getItem('txRiskLevels')) || []
    }

    saveCustomerRiskLevels(customerRiskLevels) {
        localStorage.setItem("customerRiskLevels", JSON.stringify(customerRiskLevels))
    }

    getCustomerRiskLevels() {
        return JSON.parse(localStorage.getItem('customerRiskLevels')) || []
    }

    saveCurrency(currency) {
        localStorage.setItem("currency", currency)
    }

    getCurrency() {
        return localStorage.getItem("currency") || "USD"
    }

}

export default new CommonService()
